import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Menu, MenuItem, Divider, IconButton, makeStyles } from '@material-ui/core'
import Icon from '../../../atoms/Icon'
import { ICON_NAMES } from '../../../../constants'
import { useDenaliActions } from '../provider/DenaliActionProvider'

const useStyles = makeStyles(() => ({
  iconButton: {
    backgroundColor: 'var(--theme-color-surface-d0)',
    borderRadius: 'var(--border-radius-round)',
    padding: 'var(--padding-sm)'
  },
  menuPaper: {
    minWidth: '200px',
    borderRadius: 'var(--border-radius-md)',
    border: 'var(--border-neutral-thin)',
    boxShadow: 'var(--shadow-sm)',
    backgroundColor: 'var(--theme-color-surface-d0)'
  },
  menuList: {
    padding: 0
  },
  menuItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: 'var(--gap-md)',
    alignItems: 'center',
    padding: 'var(--padding-md)',
    fontSize: 'var(--text-size-sm)',
    '&:hover': {
      backgroundColor: 'var(--color-primary-100)'
    }
  },
  menuItemIcon: {
    display: 'flex',
    alignItems: 'center'
  },
  divider: {
    borderColor: 'var(--color-neutral-300)'
  }
}))

function DenaliActionMenu ({ id, actions, subject, size, icon, className, style }) {
  const classes = useStyles()
  const { open: openAction } = useDenaliActions()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpen = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
  }, [])

  const handleClose = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    setAnchorEl(null)
  }, [])

  const handleActionClick = useCallback((action, e) => {
    openAction(action.code, subject)
    handleClose(e)
  }, [openAction, subject, handleClose])

  if (!actions || !actions.length) {
    return null
  }

  return (
    <div className={className} style={style}>
      <IconButton
        className={classes.iconButton}
        aria-controls={id}
        aria-haspopup='true'
        onClick={handleOpen}
      >
        <Icon name={icon} customSize={size} />
      </IconButton>

      <Menu
        id={id}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
        classes={{
          paper: classes.menuPaper,
          list: classes.menuList
        }}
      >
        {actions.map((action, index) => {
          if (action.type === 'divider') {
            return (
              <Divider
                key={`divider-${index}`}
                className={classes.divider}
              />
            )
          }

          return (
            <MenuItem
              key={action.code || `action-${index}`}
              onClick={(e) => handleActionClick(action, e)}
              disabled={action.disabled}
              className={classes.menuItem}
            >
              {action.icon && (
                <div className={classes.menuItemIcon}>
                  <Icon name={action.icon} customSize='16px' />
                </div>
              )}
              <span>{action.label}</span>
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}

DenaliActionMenu.propTypes = {
  id: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['action', 'divider']),
    code: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string,
    disabled: PropTypes.bool
  })).isRequired,
  subject: PropTypes.any,
  size: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

DenaliActionMenu.defaultProps = {
  id: 'denali-action-menu',
  size: '24px',
  icon: ICON_NAMES.vertDots
}

export default DenaliActionMenu
